
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.494 1.718c-.108 0-.433 0-.622 4.462h-.164a.402.402 0 00-.253.373c-.574.132-4.579 1.047-5.353 1.204a13.808 13.808 0 00-.08-.594C.957 6.902.881 6.87.821 6.87H.793a.316.316 0 00-.173.245 2.66 2.66 0 00-.12.802c.033.492.094.981.185 1.465a.1.1 0 00.1.084h.06a.1.1 0 00.1-.08l.085-.462h5.493c.076.648.189 1.291.337 1.927a.1.1 0 00.056.068l.104.048.145.509-2.159.895a.101.101 0 00-.06.101l.04.489a.1.1 0 00.1.092h2.243l.041.153a.1.1 0 00.096.076h.08a.099.099 0 00.1-.084l.025-.145h2.243a.1.1 0 00.1-.092l.04-.489a.101.101 0 00-.06-.101l-2.159-.895.145-.509.104-.048a.1.1 0 00.056-.068 17.49 17.49 0 00.337-1.927h5.493l.085.462a.1.1 0 00.1.08h.06a.1.1 0 00.1-.084c.091-.484.152-.973.185-1.465a2.66 2.66 0 00-.12-.802.306.306 0 00-.173-.241h-.028c-.06 0-.14.032-.201.285 0 .024-.06.377-.08.602-.77-.169-4.779-1.084-5.353-1.204 0-.164-.1-.312-.253-.373h-.164c-.185-4.462-.514-4.462-.622-4.462l-.012-.004z"}})])
          )
        }
      }
    